<div class="route-summary">
    <div *ngFor="let item of data" class="route-summary__item">
        <i class="{{ item.icon }} icon"></i>
        <span class="title">
            {{item.value}}
        </span>
        <span class="label">
            {{item.title}}
        </span>
    </div>
</div>